import Alpine from 'alpinejs';
import { setup } from 'virtual:@astrojs/alpinejs/entrypoint';
setup(Alpine);
window.Alpine = Alpine;
document.addEventListener('DOMContentLoaded', () => Alpine.start());
import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://e4fd873d3d10724dabb2f3f0f853b46c@o135423.ingest.us.sentry.io/4506676886831104",
  debug: false,
  environment: "dev",
  release: "yco-website@1745923895",
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});